// Minimal markdown renderer for AI chat output: tables, lists, headings,
// bold/italic/code. Input is escaped first — safe for v-html.
function inline(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    .replace(/`(.+?)`/g, "<code>$1</code>");
}

export function renderMarkdownLite(text) {
  if (!text) return "";
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  const lines = escaped.split("\n");
  let html = "";
  let inTable = false;
  let inList = false;

  const closeTable = () => { if (inTable) { html += "</tbody></table>"; inTable = false; } };
  const closeList = () => { if (inList) { html += "</ul>"; inList = false; } };

  for (const raw of lines) {
    const trimmed = raw.trim();

    // Table rows: | a | b |
    if (/^\|.*\|$/.test(trimmed)) {
      if (/^\|[\s\-:|]+\|$/.test(trimmed)) continue; // separator row |---|---|
      const cells = trimmed.slice(1, -1).split("|").map((cell) => inline(cell.trim()));
      if (!inTable) {
        closeList();
        html += '<table class="md-table"><tbody>';
        inTable = true;
        html += `<tr>${cells.map((cell) => `<th>${cell}</th>`).join("")}</tr>`;
      } else {
        html += `<tr>${cells.map((cell) => `<td>${cell}</td>`).join("")}</tr>`;
      }
      continue;
    }
    closeTable();

    // List items: - * • or 1.
    const listMatch = trimmed.match(/^(?:[-*•]|\d+\.)\s+(.*)$/);
    if (listMatch) {
      if (!inList) { html += '<ul class="md-list">'; inList = true; }
      html += `<li>${inline(listMatch[1])}</li>`;
      continue;
    }
    closeList();

    if (!trimmed) {
      html += '<div class="md-space"></div>';
      continue;
    }

    const headingMatch = trimmed.match(/^#{1,4}\s+(.*)$/);
    if (headingMatch) {
      html += `<div class="md-heading">${inline(headingMatch[1])}</div>`;
      continue;
    }

    html += `<div>${inline(trimmed)}</div>`;
  }

  closeTable();
  closeList();
  return html;
}
